 // -------------To Run in Localhost --------------------- //
// import React, { useState } from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import './Navbar.css';
// import Logo from '../Assets/logo2.png';
// import axios from 'axios';
// import { API_BASE_URL } from '../config';
// import { Navbar as BootstrapNavbar, Container, Nav } from 'react-bootstrap';

// const Navbar = () => {
//   const navigate = useNavigate();
//   const [expanded, setExpanded] = useState(false);
//   const userName = localStorage.getItem('userName') || 'Profile';

//   const handleLogout = async () => {
//     try {
//       const response = await axios.get(`${API_BASE_URL}/Logout.php`);
//       const result = response.data;

//       if (result.message === 'Logged out successfully') {
//         localStorage.removeItem('userName');
//         localStorage.removeItem('userRole');
//         localStorage.removeItem('userID');
//         localStorage.removeItem('formData');
//         localStorage.removeItem('completionStatus');
//         localStorage.removeItem('uid');
//         sessionStorage.removeItem('uid');
//         sessionStorage.removeItem('firstName');
//         sessionStorage.removeItem('email');
//         sessionStorage.removeItem('role');

//         navigate('/home');
//       } else {
//         console.error('Logout failed:', result.message);
//       }
//     } catch (error) {
//       console.error('Error during logout:', error);
//     }
//   };

//   return (
//     <BootstrapNavbar
//       expand="lg"
//       className="custom-navbar"
//       expanded={expanded}
//     >
//       <Container fluid className="nav-bar-container">
//         <div className="nav-left">
//           <img src={Logo} alt="Logo" className="Logo" />
//         </div>

//         <div className="nav-center">
//           <h1 className="main-title">RESEARCH GRANT MANAGEMENT SYSTEM</h1>
//         </div>

//         <BootstrapNavbar.Toggle
//           aria-controls="responsive-navbar-nav"
//           onClick={() => setExpanded(!expanded)}
//         />
//         <BootstrapNavbar.Collapse id="responsive-navbar-nav">
//           <Nav className="nav-right ms-auto">
//             <Link to="/home" className="nav-link" onClick={() => setExpanded(false)}>
//               Home
//             </Link>
//             <Link to="/dashboard" className="nav-link" onClick={() => setExpanded(false)}>
//               Dashboard
//             </Link>
//             <Link to="/profile" className="nav-link" onClick={() => setExpanded(false)}>
//               {userName}
//             </Link>
//             <span
//               className="nav-link logout-link"
//               onClick={() => {
//                 setExpanded(false);
//                 handleLogout();
//               }}
//             >
//               Log Out
//             </span>
//           </Nav>
//         </BootstrapNavbar.Collapse>
//       </Container>
//     </BootstrapNavbar>
//   );
// };

// export default Navbar;




// To Run in Server


import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Navbar.css';
import Logo from '../Assets/logo2.png';
import axios from 'axios';
import { API_BASE_URL } from '../config';
import { Navbar as BootstrapNavbar, Container, Nav } from 'react-bootstrap';

const Navbar = () => {
  const navigate = useNavigate();
  const [expanded, setExpanded] = useState(false);
  const [isSessionActive, setIsSessionActive] = useState(false);
  const userName = localStorage.getItem('userName') || 'Profile';

  useEffect(() => {
    const checkSession = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/CheckSession.php`);
        const result = response.data;

        if (result.status === true) {
          setIsSessionActive(true);
        } else {
          setIsSessionActive(false);
          navigate('/home');
        }
      } catch (error) {
        console.error('Error checking session:', error);
        setIsSessionActive(false);
        navigate('/home');
      }
    };

    checkSession();
  }, [navigate]);

  const handleLogout = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/Logout.php`);
      const result = response.data;

      if (result.message === 'Logged out successfully') {
        localStorage.clear();
        sessionStorage.clear();
        navigate('/home');
      } else {
        console.error('Logout failed:', result.message);
      }
    } catch (error) {
      console.error('Error during logout:', error);
    }
  };

  return (
    <BootstrapNavbar
      expand="lg"
      className="custom-navbar"
      expanded={expanded}
    >
      <Container fluid className="nav-bar-container">
        <div className="nav-left">
          <img src={Logo} alt="Logo" className="Logo" />
        </div>

        <div className="nav-center">
          <h1 className="main-title">RESEARCH GRANT MANAGEMENT SYSTEM</h1>
        </div>

        <BootstrapNavbar.Toggle
          aria-controls="responsive-navbar-nav"
          onClick={() => setExpanded(!expanded)}
        />

        <BootstrapNavbar.Collapse id="responsive-navbar-nav">
          {isSessionActive && (
            <Nav className="nav-right ms-auto">
              <Link to="/home" className="nav-link" onClick={() => setExpanded(false)}>Home</Link>
              <Link to="/dashboard" className="nav-link" onClick={() => setExpanded(false)}>Dashboard</Link>
              <Link to="/profile" className="nav-link" onClick={() => setExpanded(false)}>{userName}</Link>
              <span
                className="nav-link logout-link"
                onClick={() => {
                  setExpanded(false);
                  handleLogout();
                }}
              >
                Log Out
              </span>
            </Nav>
          )}
        </BootstrapNavbar.Collapse>
      </Container>
    </BootstrapNavbar>
  );
};

export default Navbar;
